import Tooltip from "@kea-mod/common/tooltip";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { Exercise } from "../../../types/Exercise";

type Props = {
  activeExercise: Exercise;
  h: Function;
};

export const FeedForwardThresholdField = (props: Props) => {
  const { t } = useTranslation();
  const [errorKey, setErrorKey] = useState<string | null>(null);

  const onChange = (event: any) => {
    // Accept comma as a decimal separator and enforce the 0 to 1 range.
    const raw = event.target.value.replace(",", ".");

    if (!/^\d*\.?\d*$/.test(raw)) {
      event.target.value = props.activeExercise.feedForward_threshold;
      setErrorKey("relativeScoreRange");
      return;
    }

    const num = parseFloat(raw);
    if (!isNaN(num) && (num < 0 || num > 1)) {
      event.target.value = props.activeExercise.feedForward_threshold;
      setErrorKey("relativeScoreRange");
      return;
    }

    setErrorKey(null);
    event.target.value = raw;
    props.h(event);
  };

  return (
    <div className="field">
      <label className="label" htmlFor="feedForward_threshold">
        {t("feedForward_threshold")}
        <Tooltip
          icon="circle-info"
          class="icon tooltip no-border is-white   has-tooltip-multiline has-tooltip-top"
          content={t("feedForward_threshold_tooltip")}
        ></Tooltip>
      </label>
      <input
        type="text"
        className="input"
        id="feedForward_threshold"
        name="feedForward_threshold"
        value={props.activeExercise.feedForward_threshold}
        onChange={onChange}
      />
      {errorKey && <p className="help is-danger">{t(errorKey)}</p>}
    </div>
  );
};
